import React from "react";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
import { classNames } from "./utils/classNames";
export var Title = function (_a) {
    var _b = _a.titleLevel, titleLevel = _b === void 0 ? "span" : _b, extraClass = _a.extraClass, children = _a.children, dataId = _a.dataId, dataTestId = _a.dataTestId, dataHook = _a.dataHook, styleOptions = _a.styleOptions;
    var utilities = useUtilityStyles(styleOptions).utilities;
    var Component = titleLevel;
    return (React.createElement(Component, { className: classNames(utilities, extraClass), "data-id": dataId, "data-testid": dataTestId, "data-hook": dataHook }, children));
};
